import {
  OnInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef
} from "@angular/core";
import { MainState } from "@app/store/state";
import { ThemeService, Theme } from "@core/services/theme.service";
import { Store } from "@ngrx/store";
import { BaseComponentDirective } from "@shared/components/base-component.directive";

@Component({
  selector: "astrobin-toggle-button",
  templateUrl: "./toggle-button.component.html",
  styleUrls: ["./toggle-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleButtonComponent extends BaseComponentDirective implements OnInit, OnChanges {
  model: boolean;

  @Input()
  value: boolean;

  @Input()
  label: string;

  @Input()
  labelClassName: string;

  @Input()
  disabled = false;

  @Output()
  toggle = new EventEmitter<boolean>();

  color: { checked: string; unchecked: string };
  switchColor: { checked: string; unchecked: string };
  uniqueId = Math.random().toString(36).slice(2, 11);

  constructor(
    public readonly store$: Store<MainState>,
    public readonly themeService: ThemeService,
    private readonly cdr: ChangeDetectorRef
  ) {
    super(store$);
  }

  ngOnInit(): void {
    super.ngOnInit();

    // Initialize model with the input value
    this.model = this.value || false;

    const highContrast = this.themeService.preferredTheme() === Theme.HIGH_CONTRAST;
    this.color = {
      checked: highContrast ? "#888" : "#cc4b2e",
      unchecked: highContrast ? "#000" : "#111"
    };

    this.switchColor = {
      checked: "#fff",
      unchecked: highContrast ? "#888" : "#666"
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Keep model in sync with value input
    if (changes["value"]) {
      this.model = this.value || false;
      this.cdr.markForCheck();
    }
  }
}
